/* START_MODULE_CONTRACT
 * PURPOSE: Переиспользуемые функции валидации полей прикладных форм.
 * SCOPE: isNonEmptyTrimmed, isMinLength, isIntegerInRange.
 * DEPENDS: нет
 * LINKS: M-FE-APP
 * ROLE: UTILITY
 * MAP_MODE: EXPORTS
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * isNonEmptyTrimmed - строка не пуста после trim.
 * isMinLength - минимальная длина строки.
 * isIntegerInRange - целое число в диапазоне [min, max].
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-13 - Общие валидаторы для blur-валидации в диалогах.
 * END_CHANGE_SUMMARY
 */

/* START_METHOD_isNonEmptyTrimmed */
/* START_CONTRACT: isNonEmptyTrimmed
 * PURPOSE: Проверить, что строка не пуста после обрезки пробелов.
 * INPUTS: { value: string }.
 * OUTPUTS: { boolean }.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-APP
 * END_CONTRACT: isNonEmptyTrimmed
 */
export function isNonEmptyTrimmed(value) {
  return value.trim().length > 0;
}
/* END_METHOD_isNonEmptyTrimmed */

/* START_METHOD_isMinLength */
/* START_CONTRACT: isMinLength
 * PURPOSE: Фабрика валидатора минимальной длины строки.
 * INPUTS: { min: number }.
 * OUTPUTS: { (value: string) => boolean }.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-APP
 * END_CONTRACT: isMinLength
 */
export function isMinLength(min) {
  return (value) => value.length >= min;
}
/* END_METHOD_isMinLength */

/* START_METHOD_isEmptyOrMinLength */
/* START_CONTRACT: isEmptyOrMinLength
 * PURPOSE: Фабрика валидатора: пустая строка допустима, иначе минимальная длина.
 * INPUTS: { min: number }.
 * OUTPUTS: { (value: string) => boolean }.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-APP
 * END_CONTRACT: isEmptyOrMinLength
 */
export function isEmptyOrMinLength(min) {
  return (value) => value === '' || value.length >= min;
}
/* END_METHOD_isEmptyOrMinLength */

/* START_METHOD_isIntegerInRange */
/* START_CONTRACT: isIntegerInRange
 * PURPOSE: Фабрика валидатора целого числа в диапазоне.
 * INPUTS: { min: number, max: number }.
 * OUTPUTS: { (value: string) => boolean }.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-APP
 * END_CONTRACT: isIntegerInRange
 */
export function isIntegerInRange(min, max) {
  return (value) => {
    if (value === '') return false;
    const numeric = Number(value);
    return Number.isInteger(numeric) && numeric >= min && numeric <= max;
  };
}
/* END_METHOD_isIntegerInRange */
